var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M11.9999 3L21.5262 19.5H2.47363L11.9999 3Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }